export const initialState = {
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',

};